export class FetchError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
export const makeSupportApi = (baseUrl = process.env.NEXT_PUBLIC_SUPPORT_API_URL, fetcher = fetch) => ({
    getGame: async ({ accessCode, signal }) => {
        if (!baseUrl)
            throw new FetchError(400, `SupportApi expects an api base url`);
        if (!accessCode)
            throw new FetchError(400, `SupportApi.getGame expects an access code`);
        const url = `${baseUrl}/games`;
        const headers = { Authorization: accessCode };
        const resp = await fetcher(url, { headers, signal });
        if (!resp.ok)
            throw new FetchError(resp.status, "Failed api call");
        return resp.json();
    },
    requestFullBookletUrl: async ({ accessCode, bookletId, signal }) => {
        if (!baseUrl)
            throw new FetchError(400, `SupportApi expects an api base url`);
        if (!accessCode)
            throw new FetchError(400, `SupportApi.requestFullBookletUrl expects an access code`);
        if (!bookletId)
            throw new FetchError(400, `SupportApi.requestFullBookletUrl expects a bookletId`);
        const url = `${baseUrl}/full-booklets/${bookletId}`;
        const headers = { Authorization: accessCode };
        const resp = await fetcher(url, { headers, signal });
        if (!resp.ok)
            throw new FetchError(resp.status, "Failed api call");
        const data = await resp.json();
        if (!data.downloadLink)
            throw new FetchError(resp.status, `No download link found for ${bookletId}`);
        return data.downloadLink;
    },
});
//# sourceMappingURL=api.js.map